import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { Span, semanticCSS } from '../../../../../typography/semanticTags';
import { TriangleIcon } from '../TriangleIcon';
import { getStyleBySize } from '../../../../../typography/semanticTags/semanticTags.utils';
import { useTheme } from '../../../../../theming/useTheme';

interface LinkWithSubMenuProps {
  title: string;
  hoverStateColor: string;
  idleColor: string;
  toggleMenu: (element: HTMLElement, index: number) => void;
  index: number;
  linkDropdownIconColor: string;
  linkFontSizeLarge: TypographySize;
  linkFontSizeMedium: TypographySize;
  linkFontSizeSmall: TypographySize;
}

const getStyles = (hoverStateColor: string, idleColor: string) => StyleSheet.create({
  title: {
    color: idleColor,
    cursor: 'pointer',
    ':hover': {
      color: hoverStateColor,
    },
  },
  span: {
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  menu: {
    position: 'absolute',
  },
});

export const LinkWithSubMenu: React.FunctionComponent<LinkWithSubMenuProps> = props => {
  const { title, hoverStateColor, idleColor, toggleMenu, index, linkDropdownIconColor, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall } = props;
  const [isHovering, setIsHovering] = React.useState(false);
  const { fontSizesStyles } = useTheme();
  const styles = getStyles(hoverStateColor, idleColor);
  const linkRef = React.useRef<HTMLSpanElement>(null);
  const fontStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: linkFontSizeSmall, fontSizeMedium: linkFontSizeMedium, fontSizeLarge: linkFontSizeLarge });

  const onHover = () => {
    setIsHovering(true);
  };

  const onLeave = () => {
    setIsHovering(false);
  };

  const onClick = () => {
    if (linkRef.current !== null) {
      toggleMenu(linkRef.current, index);
    }
  };

  return (
    <React.Fragment>
      <Span styles={semanticCSS(fontStyle, styles.title, styles.span)} onMouseEnter={onHover} onMouseLeave={onLeave} onClick={onClick} reference={linkRef}>
        {title}
        <TriangleIcon hoverColor={hoverStateColor} color={linkDropdownIconColor} isHovering={isHovering} />
      </Span>
    </React.Fragment>
  );
};
